var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-common-search',{attrs:{"from":'store',"value":_vm.params.keywords}}),_c('goodslist-body'),_c('common-store-footer',{attrs:{"store_id":_vm.store_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }